<template>
  <li class="login-sns-each tworld">
    <a href="#" @click.prevent="loginTid()">
      <span class="icon-sns icon-tworld"></span>
      <span class="a11y-hidden">T아이디로 로그인</span>
    </a>
  </li>
</template>

<script>
import _ from 'lodash'
import { parseUrl } from 'query-string'
import { getSktToken } from '@/common/utils/request'
import { PROMOTION_CODE_KEY } from '@/common/resources/const'

export default {
  name: 'BtnSkt',
  methods: {
    loginTid () {
      const { query: currentQuery } = parseUrl(location.href)
      const referer = _.get(currentQuery, 'referer', '')
      const { query: refererQuery } = parseUrl(referer)
      const promotionCode = _.get(refererQuery, PROMOTION_CODE_KEY, '')

      getSktToken({ promotionCode }).then((response) => {
        const targetUrl = _.get(response, ['data', 'weburl'], '')
        try {
          location.href = targetUrl
        } catch (e) {
          location.href = '/login'
        }
      })
    }
  }
}
</script>
